"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var colors = _interopRequireWildcard(require("../colors"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ascDirection = 'asc';
var descDirection = 'desc';

var Triangle = function Triangle(_ref) {
  var up = _ref.up,
      active = _ref.active,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
  return _react["default"].createElement("div", {
    style: _objectSpread({
      width: '0px',
      height: '0px',
      borderLeft: '5px solid transparent',
      borderRight: '5px solid transparent',
      borderBottom: up ? "5px solid ".concat(active ? colors.alloy : colors.shale) : 'none',
      borderTop: up ? 'none' : "5px solid ".concat(active ? colors.alloy : colors.shale)
    }, style)
  });
};

Triangle.propTypes = {
  up: _propTypes["default"].bool,
  active: _propTypes["default"].bool,
  style: _propTypes["default"].shape({})
};

var TableHeader = function TableHeader(_ref2) {
  var children = _ref2.children,
      className = _ref2.className,
      sortable = _ref2.sortable,
      sorted = _ref2.sorted,
      toggleSort = _ref2.toggleSort,
      rest = _objectWithoutProperties(_ref2, ["children", "className", "sortable", "sorted", "toggleSort"]);

  var direction = sorted && (sorted.desc ? 'desc' : 'asc');

  var sortIcons = _react["default"].createElement("div", null, _react["default"].createElement(Triangle, {
    active: direction === ascDirection,
    up: true
  }), _react["default"].createElement(Triangle, {
    active: direction === descDirection,
    style: {
      marginTop: '2px'
    }
  }));

  return _react["default"].createElement("div", _extends({
    className: (0, _classnames["default"])('rt-th', className),
    role: "columnheader",
    tabIndex: "-1"
  }, rest, {
    onClick: function onClick(e) {
      return toggleSort && toggleSort(e);
    }
  }), children, sortable ? sortIcons : null);
};

TableHeader.propTypes = {
  children: _propTypes["default"].node,
  className: _propTypes["default"].string,
  sortable: _propTypes["default"].bool,
  toggleSort: _propTypes["default"].func,
  sorted: _propTypes["default"].shape({
    desc: _propTypes["default"].any
  })
};
var _default = TableHeader;
exports["default"] = _default;